import React from 'react';
import { Text, HeaderText } from '@el8/vital';

import { formatPhone } from 'utils/format';

const PaymentsHeader: React.FC = () => {
  const { practiceContactEmail, practiceContactPhone, practiceDisplayName } = window.elate;

  return (
    <div style={{ marginBottom: 32, textAlign: 'center' }}>
      <HeaderText align="center" legacyVariant="legacyTitleText" sizing="heading-lg" tag="h1">
        {practiceDisplayName}
      </HeaderText>
      {practiceContactEmail && (
        <Text align="center" tag="div" appearance="system">
          {practiceContactEmail}
        </Text>
      )}
      {practiceContactPhone && (
        <Text align="center" tag="div" appearance="system">
          {formatPhone(practiceContactPhone)}
        </Text>
      )}
    </div>
  );
};

export default PaymentsHeader;
